
import { defineComponent } from 'vue'

export default defineComponent({
  data () {
    return {
      value: ''
    }
  },
  props: {
    label: String,
    title: String,
    pattern: String
  },
  methods: {
    submit () {
      this.$emit('search', this.value)
    }
  }
})
